module.exports = __webpack_public_path__ + "static/media/iss.e721768d.jpg";